<h1 mat-dialog-title class="pt-2 text-center"> Configuration du technicien {{Model.FirstName}} {{Model.LastName}}</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <h4>Général</h4>
        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Agence</mat-label>
                <mat-select placeholder="Agence" [(ngModel)]="Model.PlanningConfiguration.SubContractingLab">
                    @for (ex of LabList; track ex; let i = $index) {
                    <mat-option [value]="i + 1">
                        {{ ex }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Compétences</mat-label>
                <mat-select placeholder="Compétences" [(ngModel)]="Model.CompetenceList" [compareWith]="compareWith" multiple>
                    @for (comp of MasterCompetenceList; track comp; let i = $index) {
                    <mat-option [value]="comp">
                        {{ comp.Name }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row justify-content-center m-1">
            <mat-divider class="col-6"></mat-divider>
        </div>

        <h4>Départ</h4>
        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Choisir une adresse</mat-label>
                <mat-select placeholder="Choisir une adresse" (selectionChange)="departChanged($event)" >
                    @for (address of AddressList; track address) {
                    <mat-option [value]="address">
                        {{ address.DisplayName }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Adresse</mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.AdresseDepart" placeholder="Adresse " required readonly>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Latitude</mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.LatitudeDepart" placeholder="Latitude " required readonly>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Longitude </mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.LongitudeDepart" placeholder="Longitude " required readonly>
            </mat-form-field>
        </div>

        <div class="row justify-content-center m-1">
            <mat-divider class="col-6"></mat-divider>
        </div>

        <h4>Arrivée</h4>
        <div class="row ">
            <mat-form-field class="col">
                <mat-select placeholder="Choisir une adresse" (selectionChange)="arriveeChanged($event)" >
                    @for (address of AddressList; track address) {
                    <mat-option [value]="address">
                        {{ address.DisplayName }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Adresse </mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.AdresseArrivee" placeholder="Adresse " required readonly>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Latitude </mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.LatitudeArrivee" placeholder="Latitude " required readonly>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Longitude </mat-label>
                <input matInput [(ngModel)]="Model.PlanningConfiguration.LongitudeArrivee" placeholder="Longitude " required readonly>
            </mat-form-field>
        </div>

        <div class="row justify-content-center m-1">
            <mat-divider class="col-6"></mat-divider>
        </div>

        <h4>Planification</h4>
        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Heure Debut Journee</mat-label>
                <!-- <input matInput [(ngModel)]="Model.PlanningConfiguration.HeureDebutJournee" placeholder="Heure Debut Journee" required> -->
                <input matInput placeholder="Heure" [format]="24" [ngxMatTimepicker]="timepicker1" [value]="DayStartTime" readonly>
                <ngx-mat-timepicker #timepicker1 (timeSet)="DayStartTimeSet($event)"></ngx-mat-timepicker>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Heure Pause Minimale</mat-label>
                <!-- <input matInput [(ngModel)]="Model.PlanningConfiguration.HeurePauseMinimale" placeholder="Heure Pause Minimale" required> -->
                <input matInput placeholder="Heure" [format]="24" [ngxMatTimepicker]="timepicker2" [value]="MinPauseTime" readonly>
                <ngx-mat-timepicker #timepicker2 (timeSet)="MinPauseTimeSet($event)"></ngx-mat-timepicker>
            </mat-form-field>
        </div>

        <div class="row ">
            <mat-form-field class="col">
                <mat-label>Amplitude Horaire Maximale (min)</mat-label>
                <input matInput type="number" [(ngModel)]="Model.PlanningConfiguration.AmplitudeHoraireMaximale" placeholder="Amplitude Horaire Maximale (min)" required>
            </mat-form-field>

            <mat-form-field class="col">
                <mat-label>Duree Pause (min)</mat-label>
                <input matInput type="number" [(ngModel)]="Model.PlanningConfiguration.DureePause" placeholder="Duree Pause (min)" required>
            </mat-form-field>
        </div>

    </div>

    <div class="row m-1">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
            Enregistrer
        </button>
    </div>
</div>